// utils
import axios from 'axios';

import { BASE_URL } from '../config-global';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  let expiredTimer;
  const currentTime = Date.now();
  let timeLeft = exp * 1000 - currentTime;
  
  if (timeLeft < 0) {
    timeLeft = 1;
  }
  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(async () => {
    const refresh_token = localStorage.getItem('refreshToken');
    try {
      const response = await axios.post(
        `${BASE_URL}/api/token/refresh/`,
        { refresh: refresh_token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      const newAccessToken = response.data.access;
      localStorage.setItem('accessToken', newAccessToken);
      if (response.data.refresh) {
        localStorage.setItem('refreshToken', response.data.refresh);
      }

      axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
      const { exp: newExp } = jwtDecode(newAccessToken);
      tokenExpired(newExp);

    } catch (error) {
      console.error("Token refresh error:", error);
    }

  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken, refreshToken) => {
  if (accessToken && refreshToken) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    delete axios.defaults.headers.common.Authorization;
  }
};